<div [formGroup]="this.base_form_page.main_form" class="prv-flex-row">
  <span *ngIf="this.control_label" class="prv-label">{{this.control_label}}:</span>     
  <div class="prv-input-date-wrap {{this.hasErrorsClass()}}">
    <!-- ion-datetime-button has no empty state: it always displays today's date
         when the value is null. So only show it when there is a value (or the
         field is required); otherwise show a placeholder that opens the modal. -->
    <!-- display_format callers (the printed-sheet pages) get a plain button
         driven by the form control instead of ion-datetime-button: that
         element binds to its ion-datetime by ID once at load and renders the
         label through a slot, which proved unreliable with many async-mounted
         modal instances on one page (VRT's Repair Steps table) — the label
         froze even though the picker took the new value. The plain button's
         label re-renders from the control and it presents the modal directly,
         so it has neither failure mode. -->
    <!-- The label span is light DOM so page styles can left-align it —
         ion-button's shadow .button-inner centers slotted content and is not
         reachable from outside. -->
    <ion-button *ngIf="(this.isRequired() || this.hasValue()) && this.display_format" class="prv-input-date prv-input-date-value" fill="clear" size="small" (click)="date_modal.present()"><span class="prv-input-date-text">{{this.displayValue()}}</span></ion-button>
    <ion-datetime-button *ngIf="(this.isRequired() || this.hasValue()) && !this.display_format" class="prv-input-date" datetime="datetime_{{this.control_name}}"></ion-datetime-button>
    <ion-button *ngIf="!this.isRequired() && !this.hasValue()" class="prv-input-date-placeholder" fill="clear" size="small" (click)="date_modal.present()">Select Date</ion-button>
    <ion-button *ngIf="!this.isRequired() && this.hasValue()" class="prv-input-date-clear" fill="clear" size="small" (click)="this.clear()">
      <ion-icon slot="icon-only" name="close-circle"></ion-icon>
    </ion-button>
  </div>
  <!-- prv-date-modal: force fit-content sizing. ion-datetime-button normally
       tags this overlay so it renders as a small card, but when the value is
       null the button isn't rendered and date_modal.present() would open a
       full-size modal. -->
  <ion-modal #date_modal class="prv-date-modal" [keepContentsMounted]="true">
    <ng-template>
      <!-- (ionChange) writes the control explicitly in addition to the
           formControlName value accessor: same value, so the double write is
           harmless, and the label above stays correct even if the accessor's
           own listener is not wired for this instance. -->
      <ion-datetime [showDefaultButtons]="true" [showClearButton]="!this.isRequired()" presentation="date" locale="en-US" id="datetime_{{this.control_name}}" [formControlName]="this.control_name" (ionChange)="onPicked($event)"></ion-datetime>
    </ng-template>
  </ion-modal>  
</div>   
           


